import React, {useContext} from "react";


export class UnrealContentProvider {
    // e.g. https://localhost:7081/
    constructor(private readonly endpoint: string) {

    }
    getUri(relativeUri: string) {
        if (relativeUri.startsWith("/")) {
            relativeUri = relativeUri.substring(1);
        }

        return this.endpoint + relativeUri;
    }

}

export const UnrealContentContext = React.createContext<UnrealContentProvider|null>(null);
export function useUnrealContent() {
    const unrealContentProvider = useContext(UnrealContentContext);
    if (unrealContentProvider === null) throw new Error('Unreal content not properly initialized');
    return unrealContentProvider;
}
function useUnrealUri(relativeUri: string) {
    const unrealContentProvider = useUnrealContent();

    return unrealContentProvider.getUri(relativeUri);

}
export default useUnrealUri;